import { render, staticRenderFns } from "./BaseInput.vue?vue&type=template&id=28d1a71d&"
import script from "./BaseInput.vue?vue&type=script&lang=js&"
export * from "./BaseInput.vue?vue&type=script&lang=js&"
import style0 from "./BaseInput.vue?vue&type=style&index=0&id=28d1a71d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports